import { Feature } from 'geojson'
import { useMap } from 'ms-map-gl'
import { useEffect } from 'react'

interface PointSelectorPluginProps {
  layer: string
  onPointSelect: (feature: Feature) => void
  onPointDeselect: () => void
}

function PointSelectorPlugin(props: PointSelectorPluginProps) {
  const { layer, onPointSelect, onPointDeselect } = props

  const mapGl = useMap()

  useEffect(() => {
    const map = mapGl.current

    if (!map) return

    const handleDefaultClick = (event) => {
      const features = map.queryRenderedFeatures(event.point, {
        layers: [layer]
      })

      if (!features.length) {
        onPointDeselect()
      }
    }

    const handleClick = (event) => {
      const feature = event.features[0]

      if (!feature) return

      const coordinates = feature.geometry.coordinates.slice()

      // Ensure that if the map is zoomed out such that
      // multiple copies of the feature are visible, the
      // popup appears over the copy being pointed to.
      while (Math.abs(event.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += event.lngLat.lng > coordinates[0] ? 360 : -360
      }

      onPointSelect(feature)
    }

    map.on('click', handleDefaultClick)
    map.on('click', layer, handleClick)

    return () => {
      map.off('click', handleDefaultClick)
      map.off('click', layer, handleClick)
    }
  }, [layer, mapGl, onPointDeselect, onPointSelect])

  return <></>
}

export { PointSelectorPlugin }
